import * as React from "react";
import { forwardRef } from "react";
const SvgArrowDownRegions = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 30, height: 30, viewBox: "0 0 30 30", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M11 13L15.0656 17L19 13", stroke: "#434343", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgArrowDownRegions);
export { ForwardRef as ReactComponent };
